import { render } from "./TextArea.vue?vue&type=template&id=072e7422&scoped=true&ts=true"
import script from "./TextArea.vue?vue&type=script&lang=ts"
export * from "./TextArea.vue?vue&type=script&lang=ts"

import "./TextArea.vue?vue&type=style&index=0&id=072e7422&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072e7422"]])

export default __exports__